import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Seo from "../components/Seo";

const CATEGORIES = ["Aftercare","Inspiration","Feedback","Artist Spotlight","Community News","Style Deep-Dives","First Timer Guides"];

export default function BlogIndex() {
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState("all");
  const [authorType, setAuthorType] = useState("all");

  useEffect(() => {
    const params = {};
    if (category !== "all") params.category = category;
    if (authorType !== "all") params.author_type = authorType;
    api.get("/blog/posts", { params }).then((r) => setPosts(r.data));
  }, [category, authorType]);

  return (
    <div className="container-x py-12" data-testid="blog-index">
      <Seo title="Stories" path="/blog" description="Stories, guides and aftercare advice from tattoo artists and the Inkstead community."/>
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-serif text-4xl md:text-5xl">Stories</h1>
          <p className="text-black/60 mt-2">Written by artists and collectors.</p>
        </div>
        <Link to="/blog/new" className="btn-filled" data-testid="blog-write-btn">Write a post</Link>
      </div>
      <div className="mt-8 flex flex-wrap gap-2">
        <button onClick={()=>setCategory("all")} className={`badge ${category==="all"?"badge-flash":"badge-neutral"}`} data-testid="cat-all">All</button>
        {CATEGORIES.map((c) => <button key={c} onClick={()=>setCategory(c)} className={`badge ${category===c?"badge-flash":"badge-neutral"}`} data-testid={`cat-${c.replace(/\s/g,"-").toLowerCase()}`}>{c}</button>)}
      </div>
      <div className="mt-3 flex gap-2 text-xs">
        {[["all","All authors"],["artist","Artists"],["client","Clients"]].map(([v,l])=>(
          <button key={v} onClick={()=>setAuthorType(v)} className={`badge ${authorType===v?"badge-flash":"badge-neutral"}`} data-testid={`at-${v}`}>{l}</button>
        ))}
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {posts.map((b) => (
          <Link key={b.id} to={`/blog/${b.slug}`} className="card hover:-translate-y-0.5 transition-transform" data-testid={`blog-card-${b.slug}`}>
            {b.cover_image_url && <div className="aspect-[16/10] overflow-hidden rounded-[8px] mb-4"><img src={b.cover_image_url} alt={b.title} className="w-full h-full object-cover"/></div>}
            <div className="flex items-center gap-2 mb-2">
              <span className="badge badge-neutral">{b.category}</span>
              {b.author_account_type === "artist" && <span className="badge badge-flash">Artist</span>}
              {b.featured && <span className="badge badge-open">Featured</span>}
            </div>
            <h3 className="font-serif text-xl leading-snug">{b.title}</h3>
            <p className="text-sm text-black/60 mt-2">{b.author_name} · {b.read_time} min read · {b.comment_count} comments</p>
          </Link>
        ))}
        {posts.length === 0 && <p className="text-black/50">No posts in this filter.</p>}
      </div>
    </div>
  );
}
